// extracted by mini-css-extract-plugin
export var acitonButtons = "_e2-0";
export var additionalIcon = "_e2-f";
export var block = "_e2-1";
export var blockContent = "_e2-7";
export var blockDescription = "_e2-8";
export var blockIcon = "_e2-9";
export var blockTitle = "_e2-6";
export var border = "_e2-a";
export var center = "_e2-l";
export var edge = "_e2-b";
export var edgeLabel = "_e2-c";
export var edgePath = "_e2-d";
export var error = "_e2-e";
export var flowchart = "_e2-g";
export var flowchartContent = "_e2-h";
export var highlighted = "_e2-3";
export var hover = "_e2-4";
export var icon = "_e2-i";
export var left = "_e2-m";
export var navButton = "_e2-j";
export var navButtons = "_e2-k";
export var right = "_e2-n";
export var selected = "_e2-2";
export var small = "_e2-5";